import React, { useState, useEffect } from "react";
import { SelectFieldProps } from "./SelectField.types";
import {
  Description,
  ErrorMessage,
  FieldWrapper,
  Label,
  Select,
} from "./SelectField.style";
import { colors } from "../../../utils/styled/_variables.styled";

const SelectField: React.FC<SelectFieldProps> = ({
  id,
  label,
  placeholder,
  isRequired,
  requiredLabel,
  description,
  onChange,
  onValidityChange,
  optionsList = [],
  disable,
  value
}) => {
  const [selectedValue, setSelectedValue] = useState<string | undefined>(value || "");
  const [isValid, setValid] = useState(false);
  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    if (selectedValue) {
      setValid(true);
      setClicked(true);
    }
  }, [selectedValue]);

  useEffect(() => {
    if (onValidityChange) {
      onValidityChange(isValid);
    }
  }, [isValid, onValidityChange]);

  const handleBlur = () => {
    if (!selectedValue) {
      setValid(false);
    } else {
      setValid(true);
    }
    setClicked(true);
  };

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newValue = event.target.value;
    setSelectedValue(newValue);
    setValid(true);
    if (onChange) {
      onChange(newValue);
    }
  };

  const handleFocus = () => {
    setValid(true);
    setClicked(true);
  };

  const defaultOptions = [
    { value: "sim", label: "Sim" },
    { value: "não", label: "Não" },
  ];

  const optionsToRender = optionsList.length > 0 ? optionsList : defaultOptions;

  return (
    <FieldWrapper>
      {label && <Label htmlFor={id}>{label + (isRequired ? " *" : "")}</Label>}
      <div className="input__wrapper">
        <Select
          $borderColor={!isValid && isRequired && clicked}
          id={id}
          value={selectedValue}
          required={isRequired}
          onBlur={handleBlur}
          onChange={handleChange}
          disabled={disable}
          onFocus={handleFocus}
        > 
          <option value="">
            {placeholder}
          </option>
          {optionsToRender.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g clipPath="url(#clip0_4349_1297)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.4625 9.29249L11.5825 13.1725L7.7025 9.29249C7.51567 9.10523 7.26202 9 6.9975 9C6.73298 9 6.47933 9.10523 6.2925 9.29249C5.9025 9.68249 5.9025 10.3125 6.2925 10.7025L10.8825 15.2925C11.2725 15.6825 11.9025 15.6825 12.2925 15.2925L16.8825 10.7025C17.2725 10.3125 17.2725 9.68249 16.8825 9.29249C16.4925 8.91249 15.8525 8.90249 15.4625 9.29249Z"
              fill={disable ? colors.gray4 : colors.greenLight}
            />
          </g>
          <defs>
            <clipPath id="clip0_4349_1297">
              <rect width="24" height="24" fill={colors.white} />
            </clipPath>
          </defs>
        </svg>
      </div>
      {isRequired && !isValid && clicked && <ErrorMessage>{requiredLabel}</ErrorMessage>}
      {description && <Description>{description}</Description>}
    </FieldWrapper>
  );
};

export default SelectField;
